import { Swiper } from '../vendor/swiper.js';
import { A11y } from 'swiper/modules';

function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), delay);
  };
}

function originalSlides(root) {
  return Array.from(root.querySelectorAll(':scope .swiper-slide')).filter(
    (slide) => !slide.classList.contains('swiper-slide-duplicate')
  );
}

export function initCategoryNavSwiper() {
  const root = document.querySelector('[data-category-nav-swiper]');
  if (!root) return;

  const slideCount = originalSlides(root).length;
  const mobileMq = window.matchMedia('(max-width: 1023px)');
  let swiper = null;

  const shouldEnable = () => !mobileMq.matches && slideCount > 8;

  const create = () => {
    root.classList.add('is-swiper-active');

    swiper = new Swiper(root, {
      modules: [A11y],
      spaceBetween: 0,
      speed: 300,
      grabCursor: true,
      watchOverflow: false,
      maxBackfaceHiddenSlides: 0,
      observer: true,
      observeParents: true,
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 0,
          loop: false,
        },
        1024: {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 0,
          loop: false,
        },
      },
      a11y: {
        enabled: true,
      },
    });
  };

  const destroy = () => {
    if (!swiper) return;
    root.classList.remove('is-swiper-active');
    swiper.destroy(true, true);
    swiper = null;
  };

  const update = (forceRecreate = false) => {
    if (shouldEnable()) {
      if (!swiper) {
        create();
      } else if (forceRecreate) {
        destroy();
        create();
      } else {
        swiper.update();
      }
    } else {
      destroy();
    }
  };

  update();
  mobileMq.addEventListener('change', () => update(true));
  window.addEventListener('resize', debounce(() => update(false), 150));
}
